// extracted by mini-css-extract-plugin
export default {"VettedSkillCard":"iyA_X"};